import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { DialogModal } from './dialog';
const DialogServiceContext = React.createContext(() => {
    throw new Error('Please ensure you register the dialog provider!');
});
export const useDialog = () => React.useContext(DialogServiceContext);
let nextId = 0;
export const DialogServiceProvider = ({ children, }) => {
    const [dialogState, setDialogState] = React.useState(null);
    const handleSubmit = React.useCallback(() => {
        setDialogState(null);
    }, []);
    const handleClose = React.useCallback(() => {
        setDialogState((current) => {
            if (current === null || current === void 0 ? void 0 : current.blocking)
                return current;
            return null;
        });
    }, []);
    const openConfirmation = React.useCallback((options) => {
        setDialogState(Object.assign(Object.assign({}, options), { id: ++nextId }));
    }, []);
    const modal = React.useMemo(() => {
        if (!dialogState)
            return null;
        return (_jsx(DialogModal, Object.assign({ open: true, onSubmit: handleSubmit, onClose: handleClose }, dialogState)));
    }, [dialogState, handleSubmit, handleClose]);
    return (_jsxs(DialogServiceContext.Provider, Object.assign({ value: openConfirmation }, { children: [children, modal] })));
};
//# sourceMappingURL=DialogService.js.map